import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'left',
      }}
    >
      <div style={{ flexBasis: '35%', margin: '100px' }}>
        <strong>Forbidden</strong>
        <p>You do not have access to this resource.</p>
        <div>
          <p>Please check the URL or return to the homepage.</p>
          <Button variant="outlined" onClick={() => navigate('/tryrnai')}>
            Return to Home
          </Button>
        </div>
      </div>
      <img
        style={{ flexBasis: '40%', flexGrow: 0, margin: '25px' }}
        src={`${process.env.PUBLIC_URL}/404.svg`}
        alt="Forbidden"
      />
    </div>
  );
}
